import { Avatar, AvatarProps } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import React from 'react';
import { getInitials } from '../../utils/stringUtils';
interface UserAvatarProps extends Omit<AvatarProps, 'sx'> {
    size?: number;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
    name?: string;
    lastName?: string;
}

export const UserAvatar = ({ size = 32, onClick, name, lastName, ...props }: UserAvatarProps) => {
    const initials = getInitials(name, lastName);

    return (
        <Avatar
            {...props}
            onClick={onClick}
            sx={{
                width: size,
                height: size,
                cursor: onClick ? 'pointer' : 'default',
                fontSize: `${size / 2}px`,
                border: '1px solid',
                color: '#FFB300',
                borderColor: (theme) => theme.palette.mode === 'dark' ? '#614913' : '#F2D9C2',
                backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#4D3A0F' : '#FFE8B2',
            }}
        >
            {initials || <PersonIcon sx={{ fontSize: size * 0.6, color: "#FFB300" }} />}
        </Avatar>
    );
}; 